export default __webpack_public_path__ + "static/media/2930 spice rack C side.df3e7ab0.png";